import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const Content = styled.div`
  position: relative;
  background: #8a8affff;
  border: 10px solid white;
  padding: clamp(15px, 3vw, 25px);
  width: 80%;
`;

const CloseButton = styled.button`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10px;
  right: 10px;
  background: none;
  width: clamp(25px, 4vw, 35px);
  height: clamp(25px, 4vw, 35px);
  font-size: clamp(1.5rem, calc(1rem + 2vw), 2.5rem);
  font-weight: bold;
  color: white;
  transition: color 0.2s ease;
  border: none;
  cursor: pointer;

  &:hover {
    color: rgba(255, 255, 255, 0.66);
    border: 2px solid rgba(255, 255, 255, 0.66);
    transform: scale(1.01);
  }
`;

const Modal = ({ children, onClose }) => {
  return (
    <Overlay onClick={onClose}>

      <Content onClick={(e) => e.stopPropagation()}>

        <CloseButton onClick={onClose}>×</CloseButton>

        {children}

      </Content>

    </Overlay>
  );
};

export default Modal;
